import BaseRepository from '@/api/BaseRepository';
import ContactPerson from '@/models/ContactPerson';

export default class ContactPersonRepository extends BaseRepository {

    private route = 'contact-person';

    public getContactPersons(customerId: string, activeOnly?: boolean): Promise<any> {
        const params = new URLSearchParams({ customer: customerId });
        if (activeOnly) {
            params.set('active', 'true');
        }
        return this.axiosClient.get(`${this.route}?${params.toString()}`);
    }

    public createContactPerson(customerId: string, person: Partial<ContactPerson>): Promise<any> {
        return this.axiosClient.post(this.route, {
            customer: customerId,
            name: person.name,
            email: person.email,
            phone: person.phone,
            position: person.position
        });
    }

    public updateContactPerson(person: ContactPerson): Promise<any> {
        return this.axiosClient.patch(`${this.route}/${person.id}`, {
            name: person.name,
            email: person.email,
            phone: person.phone,
            position: person.position
        });
    }

    public leaveContactPerson(personId: string): Promise<any> {
        return this.axiosClient.put(`${this.route}/${personId}/leave`);
    }

    public reactivateContactPerson(personId: string): Promise<any> {
        return this.axiosClient.put(`${this.route}/${personId}/reactivate`);
    }
}
